module.exports = __webpack_public_path__ + "media/images/activeIconGuides-fa11b578.png";